module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-photo-photographer-128b5b8080eb69fa4142c07a0fe62fa5.jpg";